import * as types from './mutations-type'

const mutations = {
    [types.MUID](state, payload) {
        state.muid = payload
    },
    [types.STATUS](state, payload) {
        state.status = payload
    },
    [types.SUBJECT](state, payload) {
        state.subject = payload
    },
    [types.SENDER](state, payload) {
        state.sender = payload
    },
    [types.POINTS](state, payload) {
        state.points = payload
    },
    [types.DATE](state, payload) {
        state.date = payload
    },
    [types.FORWARDTO](state, payload) {
        state.forward_to = payload
    },
    [types.EMAILBODY](state, payload) {
        state.email_body = payload
    },
    [types.IS_LOADING](state, payload) {
        state.isloading = payload
    },
    [types.PANELIST](state, payload) {
        state.panelist_id = payload
    },
    [types.STARTTIME](state, payload) {
        state.start_time = payload
    },
    [types.ENDTIME](state, payload) {
        state.end_time = payload
    },
    [types.FIRSTNAME](state, payload) {
        state.first_name = payload
    },
    [types.LASTNAME](state, payload) {
        state.last_name = payload
    },
    [types.STATE](state, payload) {
        state.state = payload
    },
    [types.AGE](state, payload) {
        state.age = payload
    },
    [types.PANELISTEMAIL](state, payload) {
        state.panelistemail = payload
    },
    [types.FORWARDEDDATA](state, payload) {
        state.forwardeddata = payload
    },
    [types.SUBJECTDATA](state, payload) {
        state.subjectdata = payload
    },
    [types.HTMLBODY](state, payload) {
        state.htmlbody = payload
    },
    [types.EMAILREAD](state, payload) {
        state.emailRead = payload
    },
    [types.PANELISTCORE](state, payload) {
        state.panelistCore = payload
    },
    [types.PANELISTSCORE](state, payload) {
        state.panelistScore = payload
    },
    [types.INDEXNAME](state, payload) {
        state.indexName = payload
    },
    [types.DELETED](state, payload) {
        state.deleted = payload
    },
}

export default mutations
